import { CALL_API } from "redux-api-middleware";
import api from "apis/agent";
import {
  REQUEST_AGENT_SEARCHTERM,
  RECEIVE_AGENT_SEARCHTERM,
  ERROR_AGENT_SEARCHTERM,

  REQUEST_AGENT_CREATE,
  RECEIVE_AGENT_CREATE,
  ERROR_AGENT_CREATE,

  REQUEST_AGENT_RETRIEVE,
  RECEIVE_AGENT_RETRIEVE,
  ERROR_AGENT_RETRIEVE,

  REQUEST_AGENT_UPDATE,
  RECEIVE_AGENT_UPDATE,
  ERROR_AGENT_UPDATE
} from "typeConstants";
import responseHandler from "responseHandler";

const agentSearchByTerm = searchTerm => {
  return function (dispatch) {
    dispatch({
      [CALL_API]: {
        endpoint: api.agentSearch(),
        method: "POST",
        body: JSON.stringify({ searchTerm: searchTerm }),
        types: [
          REQUEST_AGENT_SEARCHTERM,
          {
            type: RECEIVE_AGENT_SEARCHTERM,
            payload: (action, state, res) =>
              res.json().then(data => {
                return data;
              })
          },
          {
            type: ERROR_AGENT_SEARCHTERM,
            payload: (action, state, res) => {
              responseHandler.error(res, dispatch);
            }
          }
        ]
      }
    });
  };
};

const agentCreate = agentInfo => {
  return function (dispatch) {
    dispatch({
      [CALL_API]: {
        endpoint: api.agentCreate(),
        method: "PUT",
        body: JSON.stringify(agentInfo),
        types: [
          REQUEST_AGENT_CREATE,
          {
            type: RECEIVE_AGENT_CREATE,
            payload: (action, state, res) =>
              res.json().then(data => {
                return data;
              })
          },
          {
            type: ERROR_AGENT_CREATE,
            payload: (action, state, res) => {
              responseHandler.error(res, dispatch);
            }
          }
        ]
      }
    });
  };
};

const agentGet = agentId => {
  return function (dispatch) {
    dispatch({
      [CALL_API]: {
        endpoint: api.agentGet(agentId),
        method: "GET",
        types: [
          REQUEST_AGENT_RETRIEVE,
          {
            type: RECEIVE_AGENT_RETRIEVE,
            payload: (action, state, res) =>
              res.json().then(data => {
                return data;
              })
          },
          {
            type: ERROR_AGENT_RETRIEVE,
            payload: (action, state, res) => {
              responseHandler.error(res, dispatch);
            }
          }
        ]
      }
    });
  };
};

const agentUpdate = agentInfo => {
  return function (dispatch) {
    dispatch({
      [CALL_API]: {
        endpoint: api.agentUpdate(agentInfo),
        method: "POST",
        body: JSON.stringify(agentInfo),
        types: [
          REQUEST_AGENT_UPDATE,
          {
            type: RECEIVE_AGENT_UPDATE,
            payload: (action, state, res) =>
              res.json().then(data => {
                return data;
              })
          },
          {
            type: ERROR_AGENT_UPDATE,
            payload: (action, state, res) => {
              responseHandler.error(res, dispatch);
            }
          }
        ]
      }
    });
  };
};

export {
  agentSearchByTerm,
  agentCreate,
  agentGet,
  agentUpdate
};
